import axios from './httpConfig.js'

//******************开放服务 -- 系统模型 ******************/
// 系统模型列表
export function GetSystemModelList(param) {
	return axios.post('/admin/service/model/list', param)
}

// 新增系统模型
export function AddSystemModel(param) {
	return axios.post('/admin/service/model/add', param)
}

// 禁用系统模型
export function DisabledSystemModel(param) {
	return axios.post('/admin/service/model/disabled', param)
}

// 删除系统模型
export function DeleteSystemModel(param) {
	return axios.post('/admin/service/model/delete', param)
}

// 修改系统模型
export function EditSystemModel(param) {
	return axios.post('/admin/service/model/edit', param)
}

// 数据库 表 列表
export function GetDataBaseList(param) {
	return axios.post('/admin/table/list', param)
}

// 数据库表字段 列表
export function GetDataBaseFieldList(param) {
	return axios.post('/admin/table/cols/list', param)
}

// 模拟运行SQL语句
export function Dryrun(param) {
	return axios.post('/admin/sql/dryrun', param)
}

// 获取SQL语句中的参数
export function GetSqlParam(param) {
	return axios.post('/admin/sql/parameter', param)
}


//******************开放服务 -- 应用管理 ******************/
// 开放应用管理列表
export function GetOpenAppList(param) {
	return axios.post('/admin/open/app/list', param)
}

// 新增开放应用管理
export function AddOpenApp(param) {
	return axios.post('/admin/open/app/add', param)
}

// 禁用开放应用管理
export function DisabledOpenApp(param) {
	return axios.post('/admin/open/app/disabled', param)
}

// 删除开放应用管理
export function DeleteOpenApp(param) {
	return axios.post('/admin/open/app/delete', param)
}

// 修改开放应用管理
export function EditOpenApp(param) {
	return axios.post('/admin/open/app/edit', param)
}

// 更新appkey
export function UpdateAppKey(param) {
	return axios.post('/admin/open/app/renew/appkey', param)
}

// 更新secretkey
export function UpdateSecretKey(param) {
	return axios.post('/admin/open/app/renew/secretkey', param)
}

// 更新token
export function UpdateToken(param) {
	return axios.post('/admin/open/app/renew/token', param)
}

//******************开放服务 -- 接口样式 ******************/
// 接口样式列表
export function GetServiceStyleList(param) {
	return axios.post('/admin/service/style/list', param)
}

// 新增接口样式
export function AddServiceStyle(param) {
	return axios.post('/admin/service/style/add', param)
}

// 禁用接口样式
export function DisabledServiceStyle(param) {
	return axios.post('/admin/service/style/disabled', param)
}

// 删除接口样式
export function DeleteServiceStyle(param) {
	return axios.post('/admin/service/style/delete', param)
}

// 修改接口样式
export function EditServiceStyle(param) {
	return axios.post('/admin/service/style/edit', param)
}

//******************开放服务 -- 开放接口 ******************/
// 开放接口列表
export function GetOpenApiList(param) {
	return axios.post('/admin/service/open/list', param)
}

// 新增开放接口
export function AddOpenApi(param) {
	return axios.post('/admin/service/open/add', param)
}

// 禁用开放接口
export function DisabledOpenApi(param) {
	return axios.post('/admin/service/open/disabled', param)
}

// 删除开放接口
export function DeleteOpenApi(param) {
	return axios.post('/admin/service/open/delete', param)
}

// 修改开放接口
export function EditOpenApi(param) {
	return axios.post('/admin/service/open/edit', param)
}

// 开放接口请求样例
export function getOpenApiExample(param) {
	return axios.post('/admin/service/open/example', param)
}